export var CHAT_EXERCISE = 'ChatExercise';
export var EXPORTED_EXERCISES = [CHAT_EXERCISE];